import { useTheme } from "@chakra-ui/react";

import { ICustomTheme } from "../types";

export const useGetThemeColors = () => {
  return (useTheme() as ICustomTheme).colors;
};
